import { useFetchProject } from "../../api/ProjectsApi"
import { Title } from "../Typography/Typography"

export const ProjectTitle = ({ projectNumber }: { projectNumber: string }) => {
    const projectInfoResponse = useFetchProject(projectNumber)

    let title = projectNumber
    if (projectInfoResponse.data?.project_long_name != null) {
        title = `${projectNumber} - ${projectInfoResponse.data?.project_long_name}`
    }

    return <Title sx={{ width: 1 }}>Project {title}</Title>
}
